<template>
    <div class="TicketSystemFaqItem">
		<div class="d-flex flex-wrap align-items-center justify-content-between mb-3">
			<div class="d-flex flex-wrap align-items-center">
				<!-- <span v-for="tg in masTopicTags" :key="tg.id">
					<span v-if="ApiData.topicTag == tg.id"  class="badge badge-primary mr-2">{{tg.value}}</span>	
				</span> -->
				<span><span v-if="topicName && topicName!='' && topicName!=undefined" class="badge badge-primary mr-2">{{topicName}}</span></span>
				<h3 class="mb-1">{{ApiData.name}}</h3>
			</div>
			<div>
				<div class="bntGroup">
					<base-button type="primary" simple @click="backByHistory()" ><i class="tim-icons icon-double-left mr-2"></i>Назад</base-button>
					<button v-if="this.$GVO.my_profile.Support == 1 || this.$GVO.my_profile.adm == 1" class="ml-3 btn btn-icon btn-simple btn-primary" @click="GoToEdit(ApiData.id)"><i class="tim-icons icon-pencil"></i></button>	
				</div>
			</div>
		</div>	

		<card>
			<div class="row">
				<div class="col-12 col-lg-8 mb-3">
					<template v-if="ApiData">
						<p v-html="ApiData.descr">
						</p>
					</template>
				</div>
				<div class="col-12 col-lg-4 sticky-container">
					<div class="sticky-item">
						<div class="moreFAQ mb-3" v-if="FAQByTopic.length>0">
							<h6 class="zipal-error-text">Больше подсказок по данной теме</h6>	
							<ReCardTicketFaq :objFAQ="faq" v-for="faq in FAQByTopic" :key="faq.id" />
						</div>
					</div>	
				</div>
			</div>
		</card>

	</div>
</template>

<script>

// import {eventEmitter} from "src/plugins/globalComponents.js";
import {Select, Option, Tooltip, Button } from 'element-ui';
import ReCardTicketFaq from 'src/our_components/ReCardTicketFaq.vue';

export default {
	name: 'TicketSystemFaqItem-page',
	components: {
        [Option.name]: Option,
        [Select.name]: Select,
        [Tooltip.name]: Tooltip,
        [Button.name]: Button,
		ReCardTicketFaq,
	},
	data() {
		return {
			ApiData: {},
			FAQByTopic: [],
			// masAllFilterParams: this.currentFilterConfig(),
			objGetParams:{},
			// masTopicTags: [],
			topicName:'',
			fullscreenLoading: false,
			// bShowFilter: false,
			bIsEdit: false,
			// currentApiFormMethod: this.currentApiFormMethodComp(),
			// masAllFormParams: this.currentFormConfig(),
			// bShowForm: false,
		};
	},
	watch: {

	},
	computed: {

	},
	methods: {
		getApiData(){
			// this.objGetParams = this.$GVO.GetAllGet();
			// let filter = {};
			// if (!this.$GVO.isEmpty(this.objGetParams)) {
			// 	//console.log('getApi',this.objGetParams);
			// 	filter = this.objGetParams;
			// }

			/*this.$GVO.ApiCall('TicketSystem.GET_TicketFAQ',{flt: {...filter,} }) */
			this.$GVO.ApiCall('TicketSystem.GET_TicketFAQ',{flt: {id:this.$route.params.faq_id} }) /**/
			.then((objApi) => {
				if(objApi.success === true){
					if(objApi.data.length > 0){
						// console.log(objApi.data);
						this.ApiData = objApi.data[0];
						// if(objApi.total!=undefined) { this.masApi_total=objApi.total; }
						this.getFAQByTopic(this.ApiData.topicTag);

						this.$GVO.LoadCatPromise('CAT_TICKET_TAGS')
						.then((objApi) => {
							if(objApi=== true){
								for (let i = 0; i < this.$GVO.cats.CAT_TICKET_TAGS.length; i++) {
									const element = this.$GVO.cats.CAT_TICKET_TAGS[i];
									// if(element.act==1) this.masTopicTags.push({'value':element.val,'label':element.val, 'id':element.id}); 
									// console.log("this.ApiData.topicTag",  this.$GVO.cats.CAT_TICKET_TAGS[i]);
									if(element.act==1 && element.id==this.ApiData.topicTag){
										this.topicName = element.name;
									}
									
								}
							}
						})
						.catch(errorObjApi => {console.error(errorObjApi); });
					}
				}else{
					this.ApiData = {};
					// this.masApi_total=0;
				}
			}).catch(errorObjApi => {this.ApiData = {}; console.error(errorObjApi);});
		},
		getFAQByTopic(topicTag){
			this.$GVO.ApiCall('TicketSystem.GET_TicketFAQ',{flt: {topicTag:topicTag, excludecurrent: this.$route.params.faq_id} }) 
			.then((objApi) => {
				if(objApi.success === true){
					if(objApi.data.length > 0){
						// console.log(objApi.data);
						this.FAQByTopic = objApi.data;
						
					}
					if(objApi.total!=undefined) { this.masApi_total=objApi.total; }
				}else{
					this.FAQByTopic = [];
					this.masApi_total=0;
				}
			}).catch(errorObjApi => {this.FAQByTopic = []; this.masApi_total=0; console.error(errorObjApi);});

		},
		backByHistory(){
			this.$router.go(-1);
		},
		GoToEdit(id){
			this.$router.push({path: '/data/TicketSystem/faq/id/'+id+'/edit'});
		},
	},
	mounted() {
		// this.objGetParams = this.$GVO.GetAllGet();

		this.getApiData();
		// console.log(location.origin);
	}
};
</script>
<style scoped>

.TicketSystemFaqItem >>>  .sticky-container {position: relative;}
.TicketSystemFaqItem >>>  .sticky-item {display: flex; flex-direction: column; position: sticky; top: 15px; z-index: 2; background: inherit;}
.TicketSystemFaqItem >>> .moreFAQ {margin-bottom: 15px; border: 1px dashed #BA54F5; border-radius: 6px; padding: 10px; grid-gap: 10px;}

.TicketSystemFaqItem >>>  .el-table table {width: 100%!important;}
.TicketSystemFaqItem >>>  .el-table .cell {word-break: break-word;}

.TicketSystemFaqItem >>> .bntGroup {
	display: flex;
	justify-content: flex-end;
}
.TicketSystemFaqItem >>> .form-options-group{
	flex-direction: row;
	width: 100%;
	align-items: baseline;
	flex-wrap: wrap;
}
.TicketSystemFaqItem >>> .form-options-group > div{
	margin-right: 5px;
}
.TicketSystemFaqItem >>> .form-group {
	margin-bottom: 0px!important;
}
.TicketSystemFaqItem >>> .cell {
	word-break: break-word!important;
}
/* .TicketSystemFaq >>> .el-table tr:hover {
    background: rgb(1, 176, 224, 0.33);
} */

.TicketSystemFaqItem >>> .photoFAQ {
	/* max-width: 700px;	 */
    height: auto;
    margin: 10px 0;
    width: 100%;
}

.TicketSystemFaqItem {
	display: flex;
	flex-direction: column;
	margin-bottom: 5px;
	/* max-width: 49%; */
}

@media (max-width: 576px){
		.filter-tag-row {padding: 0 15px;}
	}

</style>
